type QuizState =
  | { phase: 'email' }
  | { phase: 'tier1'; currentQuestion: number }
  | { phase: 'tier1-complete' }
  | { phase: 'user-info' }
  | { phase: 'tier2'; currentQuestion: number }
  | { phase: 'tier2-complete' }
  | { phase: 'tier3-qualifying' }
  | { phase: 'tier3'; currentQuestion: number }
  | { phase: 'tier3-complete' };

type AnswerData = {
  questionId: string;
  selectedIndex: number;
  isCorrect: boolean;
};

interface QuizLocalStorage {
  state: QuizState;
  sessionId: string | null;
  email: string;
  name?: string;
  qrCode: string;
  tier1Answers?: AnswerData[];
  tier2Answers?: AnswerData[];
  tier3Answers?: AnswerData[];
  answers?: (AnswerData & { timeTaken: number })[];
  tier3QualifyingAnswers?: { questionId: string; answer: boolean }[];
  qualifyingAnswers?: { questionId: string; answer: boolean }[];
  totalTimeMs?: number;
  timestamp: number;
}

const STORAGE_KEY = 'quiz_app_state';
const DEFAULT_EXPIRY_DAYS = 7;

export const saveQuizState = (data: Omit<QuizLocalStorage, 'timestamp'>) => {
  try {
    const storageData: QuizLocalStorage = {
      ...data,
      timestamp: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
  } catch (error) {
    console.error('Failed to save quiz state:', error);
  }
};

export const loadQuizState = (expiryDays: number = DEFAULT_EXPIRY_DAYS): Omit<QuizLocalStorage, 'timestamp'> | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const data: QuizLocalStorage = JSON.parse(stored);
    const expiryTime = expiryDays * 24 * 60 * 60 * 1000;

    if (Date.now() - data.timestamp > expiryTime) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    const { timestamp, ...quizData } = data;
    return quizData;
  } catch (error) {
    console.error('Failed to load quiz state:', error);
    return null;
  }
};

export const clearQuizState = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear quiz state:', error);
  }
};
